export default "__VITE_ASSET__ac77fbdd__"